import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

function ResetPasswordWithTokenDialogFooter({ submit, close, isLoading }) {
  return (
    <div className="els-btn-group-right forgot-password-dialog__footer">
      <Button
        buttonConfig={{
          type: 'tertiary',
          size: 'sm',
          label: 'Cancel',
          e2eName: 'reset-password-with-token-cancel',
        }}
        iconConfig={{
          name: 'delete',
          size: 'tiny',
        }}
        disabled={isLoading}
        onClick={close}
      />

      <Button
        buttonConfig={{
          type: 'primary',
          size: 'sm',
          label: 'Save',
          e2eName: 'reset-password-with-token-continue',
        }}
        iconConfig={{
          name: 'chevron-right',
          size: 'sm',
        }}
        disabled={isLoading}
        onClick={submit}
      />
    </div>
  );
}

ResetPasswordWithTokenDialogFooter.propTypes = {
  submit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default ResetPasswordWithTokenDialogFooter;
